/** @format */
import { Icon } from '@mpb-com/feather/components/atoms/icon';
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React, { FunctionComponent } from 'react';

import { StyledIconListItem } from './index';
import { IconListItemSkeletonProps } from './types';

export const defaultTestId = 'icon-list-item-skeleton';

export const IconListItemSkeleton: FunctionComponent<
    IconListItemSkeletonProps
> = ({
    'data-testid': dataTestId = defaultTestId,
    className,
    ...iconProps
}) => (
    <StyledIconListItem data-testid={dataTestId} className={className}>
        <Icon
            {...iconProps}
            isLoading
            className="icon"
            data-testid={`${dataTestId}__icon`}
        />
        <div className="content" data-testid={`${dataTestId}__content`}>
            <Skeleton variant={SkeletonVariant.TEXT} />
        </div>
    </StyledIconListItem>
);
